



import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import axios from 'axios';
import Papa from 'papaparse'; // CSV parser
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const AddPlanDrawer2 = ({ planName, brandName, fetchUpdatedData }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [username, setUsername] = useState('');
  const [listNameInput, setListNameInput] = useState('');
  const [selectedList, setSelectedList] = useState('');
  const [fetchedData, setFetchedData] = useState([]);
  const [recentInfluencers, setRecentInfluencers] = useState([]);
  const [data, setData] = useState([]);
  const [urlList, setUrlList] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

  const extractUrls = (text) => {
    const rawUrls = text
      .split(/[\s,;\n]+/)
      .map(str => str.trim())
      .filter(str => str.includes("instagram.com"));
    return [...new Set([...urlList, ...rawUrls])];
  };

  const handleInputChange = (e) => {
    setUsername(e.target.value);
  };

  const handleUrlEnter = async (e) => {
    if (e.key === 'Enter') {
      const urlsToFetch = extractUrls(username);
      if (!urlsToFetch.length) return;

      setUrlList(urlsToFetch);
      setUsername('');

      try {
        const res = await axios.post('https://server-side-influencer.onrender.com/bulkadd', {
          urls: urlsToFetch
        });

        setFetchedData(res.data.results || []);
      } catch (err) {
        toast.error('Failed to fetch influencer data.');
        console.error('Bulk Fetch Error:', err);
      }
    }
  };

  const handleCsvUpload = (file) => {
    Papa.parse(file, {
      complete: async (results) => {
        const flat = results.data.flat().map(entry => String(entry).trim());
        const urls = extractUrls(flat.join('\n'));
        setUrlList((prev) => [...new Set([...prev, ...urls])]);

        try {
          const res = await axios.post('https://server-side-influencer.onrender.com/bulkadd', {
            urls
          });

          const newFetched = res.data.results || [];
          setFetchedData(newFetched);

          // Mark the valid influencers
          const validInfluencers = newFetched.filter(item => item.data && item.data.data);
          const invalidInfluencers = newFetched.filter(item => !(item.data && item.data.data));

          // Show the valid influencers with tick (✅) and invalid with cross (❌)
          setFetchedData(validInfluencers);

          if (validInfluencers.length > 0) {
            await handleAddInfluencer(validInfluencers);
          } else {
            toast.error('No valid influencers found in the CSV links.');
          }
        } catch (err) {
          toast.error('CSV upload failed.');
          console.error('CSV upload error:', err);
        }
      },
      error: (error) => {
        toast.error('CSV parsing error.');
        console.error("PapaParse error:", error);
      }
    });
  };

  const handleAddInfluencer = async (validInfluencers) => {
    const userId = localStorage.getItem("brandID");
    const listName = selectedList === 'custom' ? listNameInput : selectedList;

    const influencersToAdd = validInfluencers
      .map((item) => {
        const d = item.data.data;

        const payload = {
          brandName,
          planName,
          listName,
          cid: d.cid,
          socialType: d.socialType || 'INST',
          groupID: d.groupID || d.cid,
          name: d.name,
          image: d.image,
          url: d.url,
          screenName: d.screenName,
          usersCount: d.usersCount,
          tags: d.tags,
          avgER: d.avgER,
          avgLikes: d.avgLikes || 0,
          avgComments: d.avgComments || 0,
          avgInteractions: d.avgInteractions || 0,
          avgViews: d.avgViews || 0,
          contactEmail: d.contactEmail || '',
          userID: userId
        };

        console.log("📦 Sending influencer to createplan:", payload);
        return payload;
      });

    try {
      await Promise.all(influencersToAdd.map(influencer =>
        axios.post('https://server-side-influencer.onrender.com/brand/createplan', influencer)
      ));

      toast.success('Influencers added successfully!');

      // Fetch updated data from parent component
      if (fetchUpdatedData) fetchUpdatedData();

      toggleDrawer();
    } catch (error) {
      toast.error("Failed to add one or more influencers.");
      console.error("❌ Create Plan API Error:", error);
    }
  };

  const handleListNameChange = (e) => setListNameInput(e.target.value);
  const handleSelectList = (e) => {
    setSelectedList(e.target.value);
    setListNameInput('');
  };

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('recentInfluencers')) || [];
    setRecentInfluencers(stored.slice(0, 5));

    axios.post('hhttps://server-side-influencer.onrender.com/brand/plansnames', { planName })
      .then((res) => setData(res.data.data || []))
      .catch((err) => console.error("List fetch error:", err));
  }, [planName]);

  const listNames = Array.from(new Set(data.flatMap(d => d.brandPlans.map(p => p.listName))));

  return (
    <div>
      <div className="text-center">
        <button
          className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 mb-2 flex items-center justify-center gap-2 ml-10"
          type="button"
          onClick={toggleDrawer}
        >
          <span>Add influencers</span>
          <AddIcon sx={{ fontSize: 20 }} />
        </button>
      </div>

      <div
        className={`fixed top-0 right-0 z-40 h-screen overflow-y-auto bg-white transition-transform duration-300 ease-in-out ${
          isDrawerOpen ? 'translate-x-0' : 'translate-x-full'
        } w-full sm:w-[420px] lg:w-[590px] xl:w-[590px] p-6 shadow-xl`}
      >
        <div className="flex justify-between items-center mb-10 mt-12">
          <h2 className="text-xl font-bold text-gray-800">Add Influencer</h2>
          <IconButton onClick={toggleDrawer}>
            <CloseIcon />
          </IconButton>
        </div>

        <FormControl fullWidth sx={{ mb: 4 }}>
          <InputLabel>Choose or Create List</InputLabel>
          <Select value={selectedList} onChange={handleSelectList} label="Choose or Create List">
            {listNames.map((list, index) => (
              <MenuItem key={index} value={list}>{list}</MenuItem>
            ))}
            <MenuItem value="custom">Create New List</MenuItem>
          </Select>
        </FormControl>

        {selectedList === 'custom' && (
          <input
            type="text"
            placeholder="Enter List Name"
            value={listNameInput}
            onChange={handleListNameChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md mb-6"
          />
        )}

        <TextField
          label="Enter Instagram URLs (comma, space, newline)"
          variant="outlined"
          fullWidth
          multiline
          rows={3}
          value={username}
          onChange={handleInputChange}
          onKeyDown={handleUrlEnter}
          sx={{ mb: 4 }}
        />

        {/* CSV Uploads */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">Or upload CSV with Instagram URLs</label>
          <input
            type="file"
            accept=".csv"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) handleCsvUpload(file);
            }}
            className="block w-full text-sm text-gray-500
                     file:mr-4 file:py-2 file:px-4
                     file:rounded-md file:border-0
                     file:text-sm file:font-semibold
                     file:bg-purple-50 file:text-purple-700
                     hover:file:bg-purple-100"
          />
        </div>
        <div className="mt-4">
          <h3 className="font-semibold text-gray-700 mb-2">Influencers Links</h3>
          {fetchedData.length > 0 ? (
            <div className="space-y-3">
              {fetchedData.map((item, index) => (
                <div key={index} className="flex items-center gap-4">
                  <span className="text-sm break-all">{item.url}</span>
                  {item.data && item.data.data ? <span className="text-green-600 font-bold">✅</span> : <span className="text-red-600 font-bold">❌</span>}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-400">No URLs added yet.</p>
          )}
        </div>

        <button
          onClick={() => handleAddInfluencer(fetchedData)}
          className="mt-6 w-full text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5"
        >
          Add Influencers
        </button>
      </div>
    </div>
  );
};

export default AddPlanDrawer2;
